export default __webpack_public_path__ + "static/media/drivers-opcua.f52f794d.yaml";